var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgOrderFooter = function SvgOrderFooter(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.655 2.998a3 3 0 0 1 2.12.878l7 6.996a2.998 2.998 0 0 1 0 4.24l-5.656 5.654a3 3 0 0 1-4.242 0L3.878 13.77A2.998 2.998 0 0 1 3 11.65V5.996a2.999 2.999 0 0 1 3-2.998h5.655zm.707 2.292a1 1 0 0 0-.707-.293H5.999a1 1 0 0 0-1 1v5.653a1 1 0 0 0 .293.707l6.999 6.995a1 1 0 0 0 1.414 0L19.36 13.7a1 1 0 0 0 0-1.413L12.362 5.29z",
    fill: "#667695"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.002 8.992a2 2 0 1 1-3.998-.001 2 2 0 0 1 3.998 0z",
    fill: "#667695"
  })));
};

export default SvgOrderFooter;